import React, { Fragment, useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import { forceCheck } from 'react-lazyload';

// Full User Agent: Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/61.0.3159.5 Safari/537.36 Prerender (+https://github.com/prerender/prerender)
const isPrerenderBot = navigator.userAgent.includes('Prerender');

const PrerenderSafeLazyLoad = ({ children, disable, height, ...other }) => {
  useEffect(() => {
    if (!disable || !isPrerenderBot) {
      forceCheck();
    }
  }, [disable]);
  if (isPrerenderBot || disable) {
    return <Fragment>{children}</Fragment>;
  } else if (children) {
    return (
      <LazyLoad
        once
        placeholder={
          <div style={{ flexBasis: '100%', height: `${height}px` }}></div>
        }
        offset={1000}
        {...other}
      >
        {children}
      </LazyLoad>
    );
  } else {
    return null;
  }
};

export default PrerenderSafeLazyLoad;
